export default {"src":"/_next/static/media/card-fill.5317d2e9.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};